module.exports = __webpack_public_path__ + "static/media/voucher-icon.6b20dc5c.svg";